import React from 'react';
import './Section-Separator.css';

const sectionSeparator = () => {
    return <div className="section-separator" />
};
export default sectionSeparator;